module.exports = __webpack_public_path__ + "img/quotes-1.d99462eb.webp";